import React, { useContext } from 'react';
import { NavbarHelixIcon } from './NavbarHelixIcon.js';
import { NavbarContext } from './NavbarContext.js';

var NavbarExpandButton = function NavbarExpandButton(_ref) {
  var expandIconActive = _ref.expandIconActive,
      onExpandIconClick = _ref.onExpandIconClick;

  var _useContext = useContext(NavbarContext),
      setShowMobileApplicationSwitcher = _useContext.setShowMobileApplicationSwitcher,
      setShowMobileNotifications = _useContext.setShowMobileNotifications,
      setShowMobileMenu = _useContext.setShowMobileMenu;

  var handleNavbarExpandButtonClick = function handleNavbarExpandButtonClick() {
    onExpandIconClick && onExpandIconClick();
    setShowMobileApplicationSwitcher(false);
    setShowMobileNotifications(false);
    setShowMobileMenu(false);
  };

  return React.createElement("button", {
    "aria-label": expandIconActive ? 'Collapse' : 'Expand',
    className: 'helix-unified-nav__nav-button helix-unified-nav__nav-button-drawer',
    onClick: function onClick() {
      return handleNavbarExpandButtonClick();
    }
  }, React.createElement(NavbarHelixIcon, {
    iconName: expandIconActive ? 'close_drawer' : 'open_drawer'
  }));
};

export { NavbarExpandButton as default };